/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import eventImage from "../../../../assets/images/eventImages/eventImage.jpg";

import { useNavigate, useParams } from "react-router-dom";
import { useCreateEventContext } from "../../../../context/CreateEventContext";
import ModalLoadingState from "../../../PopUpModal/ModalLoadingState";
import {
  convertTo12HourFormat,
  formatDateIntoString,
} from "../../../../utils/dateAndTime";
import SocialMediaHandles from "../../../SocialMediaHandles/SocialMediaHandles";

const Faq = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const eventId = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const { getEventData, eventData } = useCreateEventContext();

  useEffect(() => {
    if (eventId.id) {
      const fetchEvent = async () => {
        setIsLoading(true);
        try {
          const event = await getEventData(eventId.id);
        } catch (error) {
          console.log("error fetching event", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchEvent();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {isLoading ? (
        <ModalLoadingState />
      ) : (
        <div className="w-full p-6">
          <p className="mb-7 pl-1 pr-1 sm:pr-8 sm:pl-8 text-xl font-medium text-grey-900">
            {t('eventDetails.frequentlyAskedQuestions')}
          </p>
          <div className="flex flex-col space-y-6 rounded-2xl pl-1 pr-1 sm:pr-8 sm:pl-8 max-w-[70%]">
            {eventData?.faqList &&
            eventData.faqList.some(
              (faq) => faq.question.trim() !== "" && faq.answer.trim() !== "",
            ) ? (
              eventData.faqList.map((faq, index) => (
                <div key={index} className="space-y-2">
                  <div className="space-y-1">
                    <p className="text-grey-900 mb-2 leading-relaxed">
                      {faq.question}
                    </p>
                    <p className="text-grey-600 mb-2 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-grey-600">
                {t('mpsDetails.noFaqs')}
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Faq;
